export default "__VITE_ASSET__5PQTKeu$__"